import { render, staticRenderFns } from "./DoomyView.vue?vue&type=template&id=18317ad6&scoped=true&"
import script from "./DoomyView.vue?vue&type=script&lang=js&"
export * from "./DoomyView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18317ad6",
  null
  
)

export default component.exports